(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hlf-purchase-guidance"] && !Shopify.designMode) return;
  try {
    function getHlfSelectedFormat(productGrid) {
    const selectedControls = [
      ...productGrid.querySelectorAll("variant-picker input[type='radio']:checked"),
      ...productGrid.querySelectorAll('variant-picker select option:checked'),
    ];

    const selectedValues = selectedControls
      .map((control) => {
        const value = control.value || control.getAttribute('aria-label') || control.textContent || '';
        return value.toLowerCase().replace(/\s+/g, ' ').trim();
      })
      .join(' ');

    if (selectedValues.includes('printed') && selectedValues.includes('download')) return 'combined';
    if (selectedValues.includes('download') || selectedValues.includes('digital')) return 'digital';
    return 'printed';
  }

  function updateHlfPurchaseGuidance(root) {
    root.querySelectorAll('.hlf-purchase-guidance').forEach((guidance) => {
      const productGrid = guidance.closest('.product-information__grid');
      if (!productGrid) return;

      const selectedFormat = getHlfSelectedFormat(productGrid);

      guidance.dataset.hlfSelectedFormat = selectedFormat;
    });
  }

  function scheduleHlfPurchaseGuidanceUpdate(root) {
    updateHlfPurchaseGuidance(root);
    requestAnimationFrame(() => updateHlfPurchaseGuidance(root));
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches("variant-picker input[type='radio'], variant-picker select")) {
      scheduleHlfPurchaseGuidanceUpdate(document);
    }
  });

  document.addEventListener('product:select', (event) => {
    scheduleHlfPurchaseGuidanceUpdate(document);
    event.detail?.promise?.finally(() => scheduleHlfPurchaseGuidanceUpdate(document));
  });

  document.addEventListener('shopify:section:load', (event) => {
    scheduleHlfPurchaseGuidanceUpdate(event.target);
  });

  scheduleHlfPurchaseGuidanceUpdate(document);
  } catch(e) { console.error(e); }
})();

})();
